import { all, fork } from 'redux-saga/effects';

import PostSaga from './posts/postSaga';
import { userSaga } from './account/userSaga';
import { orderStatusSaga } from './orderStatus/orderStatusSaga';
import { stockStatusSaga } from './stockStatus/stockStatusSaga';
import { shipmentStatusSaga } from './shipmentStatus/shipmentStatusSaga';
import { materialSaga } from './material/materialSaga';
import { yarnSaga } from './yarn/yarnSaga';
import { threadSaga } from './thread/threadSaga';
import { weaveSaga } from './weave/weaveSaga';
import { colorSaga } from './color/colorSaga';
import { unitSaga } from './unit/unitSaga';
import { compositionSaga } from './composition/compositionSaga';
import { weaveColorSaga } from './weavecolor/weaveColorSaga';
import { weaveFactorSaga } from './weavefactor/weaveFactorSaga';
import { currencySaga } from './currency/currencySaga';
import { weaveTypeSaga} from './weaveType/weaveTypeSaga';
import { usersSaga } from './users/usersSaga';
import { customerSaga } from './customer/customerSaga';
import { supplierSaga } from './supplier/supplierSaga';
import { shipmentSaga } from './shipment/shipmentSaga';
import { stockSaga } from './stock/stockSaga';
import { orderSaga } from './order/orderSaga';
import { productSaga } from './product/productSaga';
import { supplierTypeSaga } from './supplierType/supplierTypeSaga';
import { sampleSaga } from './sample/sampleSaga';
import { orderSupplierSaga } from './orderSupplier/orderSupplierSaga';

export default function* rootSaga() {
  yield all([
    fork(PostSaga),
    userSaga(),
    orderStatusSaga(),
    stockStatusSaga(),
    shipmentStatusSaga(),
    materialSaga(), 
    yarnSaga(),
    threadSaga(),
    weaveSaga(),
    colorSaga(),
    unitSaga(),
    compositionSaga(),
    weaveColorSaga(),
    weaveFactorSaga(),
    currencySaga(),
    weaveTypeSaga(),
    usersSaga(),
    customerSaga(),
    supplierSaga(),
    shipmentSaga(),
    stockSaga(),
    orderSaga(),
    productSaga(),
    supplierTypeSaga(),
    sampleSaga(),
    orderSupplierSaga()
  ]);
}
